module.exports = __webpack_public_path__ + "b834c5578452771c5f45d00f3ee18269.png";